import { Outlet, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import Header from '../header/Header';
import NavBar from './navbar/Navbar';

const CommonLayout = () => {
  const location = useLocation();
  const mainPaths = ['/ko/main', '/en/main'];
  const isNotMain = !mainPaths.includes(location.pathname);

  return (
    <Container className="layout-container">
      <Layout>
        <ContentWrapper>
          <Header />
          <Section>
            <NavBar />
            <MainContent data-layout={isNotMain}>
              <Outlet />
            </MainContent>
          </Section>
          <BottomArea />
        </ContentWrapper>
      </Layout>
    </Container>
  );
};

export default CommonLayout;

const Container = styled.div`
  width: 100vw;
  height: 100vh;
  overflow-x: auto;
  display: flex;
  background: white;
`;

const Layout = styled.div`
  width: 100%;
  max-width: 1920px;
  padding: 0 30px;
  box-sizing: border-box;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
`;

const ContentWrapper = styled.div`
  width: 1430px;
  min-width: 1430px;
  min-height: 1080px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  background: white;
`;

const Section = styled.div`
  display: flex;
  flex: 1;
  box-sizing: border-box;
`;

const MainContent = styled.main`
  flex: 1;
  box-sizing: border-box;
`;

const BottomArea = styled.div`
  height: 100px;
  min-height: 100px;
  background: white;
`;
